import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import { useCallCenterForm } from "../hooks/useCallCenterForm";

import TextField from "@mui/material/TextField";

const TextInput = styled(TextField)(() => ({
  padding: "4px",
}));

const Email = () => {
  const { errors, formValues, handleInputChange, handleInputFocus } =
    useCallCenterForm();

  useEffect(() => {}, [formValues]);

  const handleErrorText = () => {
    if (!errors?.email) {
      return null;
    }

    return errors?.email;
  };

  return (
    <TextInput
      sx={{ flex: 1 }}
      name="email"
      label="Email"
      onChange={handleInputChange}
      onFocus={handleInputFocus}
      value={formValues?.email}
      helperText={handleErrorText()}
      error={!!errors?.email}
    />
  );
};

export default Email;
